import { FC } from "react";
import cx from 'classnames';
import styles from './index.module.scss';
import { CommonImage } from "@/components";
import { ImageType } from "@/components/CommonImage";
import { pagePathUrl } from "@/constants/url";

export interface CircleCardProps {
  name: string;
  slug: string;
  weight: number;
  className: string;
  avatar_image?: string;
}

const CircleCard: FC<CircleCardProps> = (props) => {

  const {
    name,
    slug,
    className,
    avatar_image,
  } = props;

  return (
    <div
      onClick={() => {
        window.open(`${pagePathUrl.devicesSeries}?series=${slug}`);
      }}
      className={cx(styles.circleCard, className)}
    >
      <div className={styles.image}>
        <CommonImage
          alt={name}
          layout="fill"
          cutMode="fill"
          type={ImageType.device}
          src={avatar_image || 'https://test-static.djicdn.com/dji-bbs/v1/_next/static/media/default-device.f45a712f.png'}
        />
      </div>
      <div className={styles.name}>
        {name}
      </div>
    </div>
  )
};

export default CircleCard;
